import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom Form Control Validator -- Triggers a field required form validation message if the "message" parameter is not empty
export function epRequiredIf(message: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return message && message > '' ? { required: { value: control.value, message: message } } : null;
  };
}

// Custom Form Control Validator -- Triggers a form validation error if the "message" parameter is not empty
export function epValidIf(message: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return message && message > '' ? { validIf: { value: control.value, message: message } } : null;
  };
}

// Custom Form Control Validator -- Triggers a form validation error if the value is not within min/max range
export function epRange(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let inRange: boolean = true;
    if (control.value) {
      let controlValue: number = parseFloat(control.value);
      if (controlValue < min || controlValue > max) {
        inRange = false;
      }
    }
    return inRange ? null : { range: { value: control.value, min: min, max: max } };
  };
}

// EPStateValidators defines a set of validation functions that are used when validating against state (vs angular form validation).  These
// These functions do the same type of evaluation as thier form validation function counterparts.
export class EPStateValidators {
  static required(value: string) {
    if (value == null) {
      return false;
    }
    if (String(value).trim() == '') {
      return false;
    }
    return true;
  }

  static requiredIf(value: string, fnCondition: any) {
    if (fnCondition == false) {
      return true; //  field is only required if condition is true
    }
    if (value == null) {
      return false;
    }
    if (String(value).trim() == '') {
      return false;
    }
    return true;
  }

  static validIf(fnCondition: any) {
    if (fnCondition == false) {
      return false; //  field is valid if condition is true
    }
    return true;
  }

  static minLength(value: string, min: number) {
    if (value == null) {
      return false;
    }
    if (String(value).trim().length < min) {
      return false;
    }
    return true;
  }

  static maxLength(value: string, max: number) {
    if (value == null) {
      return false;
    }
    if (String(value).trim().length > max) {
      return false;
    }
    return true;
  }

  static range(value: string, min: number, max: number) {
    if (value == null) {
      return false;
    }
    let numValue = parseInt(value, 10);
    if (numValue < min || numValue > max) {
      return false;
    }
    return true;
  }
}
